

export const assessmentGroups = [
    "Custom",
    "KAMS", 
    "KamsExpress",
    "KamsGolf",
    "KamsGolfExpress",
    "KAMSIL",
    "KAMSJoint3D",
    "ROFW"
]
export const modules = [
    "Balance",
    "ClinicalGait",
    "BridgePosture",
    "FiveXSitToStand",
    "Functional",
    "Gait",
    "GolfStanceTorsoRotation",
    "GolfStancePelvicRotation",
    "GolfPosture",
    "GolfSwingAnalysis",
    "HandFlexibility",
    "HeelRaise",
    "ModifiedCtSib",
    "ModifiedVeles",
    "OverheadSquat",
    "Posture",
    "PostureAngel",
    "PronePlankPosture",
    "ROM",
    "ReverseLunge",
    "SidePlankPosture",
    "SingleLegHop",
    "SitToStand",
    "TimedUpAndGo",
    "VerticalJump",
    "Wheelchair"
   
]

export const KamsModuleList = "ROM,OverheadSquat,ReverseLunge,PostureAngel,Balance,VerticalJump";
export const KamsExpressModuleList = "ROM,PostureAngel,OverheadSquat";
export const KamsIlModuleList = "ROM,PostureAngel,ModifiedCtSib,ReverseLunge,FiveXSitToStand";
export const KamsGolfModuleList = "GolfStanceTorsoRotation,GolfStancePelvicRotation,GolfPosture,OverheadSquat,PostureAngel,ROM,Balance,PronePlankPosture,SidePlankPosture,BridgePosture";
export const KamsGolfExpressModuleList = "GolfStanceTorsoRotation,GolfStancePelvicRotation,GolfPosture,OverheadSquat,PostureAngel,ROM";
export const KamsJoint3DModuleList = "Posture,OverheadSquat,ROM";
export const ROFWorkflowModuleList = "Gait,ModifiedCtSib,TimedUpAndGo,FiveXSitToStand"; // Not sure what the naming is


export const features = [
    "AdvancedCsvExport",
    "AdvancedDataTools",
    "API",
    "BulkUpload",
    "Correctives",
    "Correctives_Core",
    "Correctives_MoveU",
    "Correctives_PTGenie",
    "Correctives_RockTape",
    "DualRoms",
    "Fpm",
    "FpmDisplaySpinalSegments",
    "FpmExport",
    "KAMS", 
    "KamsExpress",
    "KamsGolf",
    "KamsGolfExpress",
    "KAMSIL",
    "KAMSJoint3D",
    "KinetisenseRtm",
    "LoadExternalVideo",
    "NeutralShoulderRoms", 
    "PatientAppInvite",
    "PatientGroups",
    "RiskOfFallWorkflow",
    "SupineRoms", 
    "WhiteLabel",
    "Workflow",
    "WorkflowFpmCount-3",
    "WorkflowFpmCount-5",
    "WorkflowFpmCount-10",
    "WorkflowFpmCount-15",
    "WorkflowFpmCount-20",
    "WorkflowFpmCount-100"
]
export const mainFeatures = [
    "AdvancedCsvExport",
    "AdvancedDataTools",
    "API",
    "BulkUpload",
    "DualRoms",
    "FpmDisplaySpinalSegments",
    "FpmExport",
    "KinetisenseRtm",
    "LoadExternalVideo",
    "NeutralShoulderRoms", 
    "PatientAppInvite",
    "PatientGroups",
    "WhiteLabel",
    "Workflow",
    "WorkflowFpmCount-3",
    "WorkflowFpmCount-5",
    "WorkflowFpmCount-10",
    "WorkflowFpmCount-15",
    "WorkflowFpmCount-20",
    "WorkflowFpmCount-100"
]
export const correctivesFeatures = [
    
    "Correctives",
    "Correctives_Core",
    "Correctives_MoveU",
    "Correctives_PTGenie",
    "Correctives_RockTape"
]

export const LicenceTypes = [
    "kinetisense-flex",
    "kinetisense-360",
    "kinetisense-diamond",
    "kinetisense-whitelabel",
    "kinetisense-premium",
    "kinetisense-workflow",
    "kinetisense-kams",
    "kinetisense-sdk",
    "kinetisense-360-longitude6"
]

export const AppsType = [
    {value:0,label:"Kinetisense"},
    {value:1,label:"Parker"},
    {value:2,label:"Metis"},
    {value:3,label:"Fluid"},
    {value:4,label:"KONGiQ"},
    {value:5,label:"Longitude6"},
    {value:6,label:"UofA"}
];

export const ServerList = [
        {url:"https://kinetisensecloudeducation.azurewebsites.net", name:"Education"},
        {url:"https://kinetisensecloudDevApp.azurewebsites.net", name:"DEV"},
        {url:"https://kinetisensecloudeastusapp.azurewebsites.net", name:"East USA"},
        {url:"https://kinetisensecloudcentralcanada.azurewebsites.net", name:"Central Canada"},
        {url:"https://kinetisensecloudwestusapp.azurewebsites.net", name:"West USA"},
        {url:"https://kinetisensecloudeastasiaapp.azurewebsites.net", name:"East Asia"},
        {url:"https://kinetisensecloudwesteurope.azurewebsites.net", name:"West Europe"},
        {url:"https://kinetisensecloudsoutheastaustralia.azurewebsites.net", name:"Australia"},
        {url:"https://kinetisensesubscriptionsystem.azurewebsites.net", name:"Subscription"},
        {url:"https://kinetisensesubscriptionsystemdev.azurewebsites.net", name:"Subscription DEV"},
        {url:"http://localhost:5000", name:"Local"},
        {url:"https://kinetisensedotnet8testserver-h2dzgya2g6ema4b5.canadacentral-01.azurewebsites.net", name:".net8"}
       
]

// export const LicenceTemplates = [
//     {
//         displayName:"Kinetisense Flex 360",
//         modules:"ROM,Posture,Functional,Balance,ModifiedVeles,OverheadSquat,PostureAngel,ReverseLunge,VerticalJump,SingleLegHop,ClinicalGait",
//         features:"NeutralShoulderRoms,SupineRoms,DualRoms,Workflow,KAMS"
//     },
//     {    
//         displayName:"Kinetisense Flex Diamond",
//         modules:"ROM,Posture,Functional,Balance,ModifiedVeles,OverheadSquat,PostureAngel,ReverseLunge,VerticalJump,SingleLegHop,Gait,ClinicalGait,Wheelchair,TimedUpAndGo,SitToStand,FiveXSitToStand,ModifiedCtSib",
//         features:"AdvancedDataTools,AdvancedCsvExport,BulkUpload,LoadExternalVideo,FpmExport,PatientGroups,RiskOfFallWorkflow,WhiteLabel,NeutralShoulderRoms,SupineRoms,DualRoms,Workflow,KAMS,PatientAppInvite"
//     },
//     {
//         displayName:"Kinetisense Flex Senior Living",
//         modules:"ROM,Posture,Functional,Balance,ModifiedVeles,OverheadSquat,PostureAngel,ReverseLunge,VerticalJump,Gait,ClinicalGait,Wheelchair,TimedUpAndGo,SitToStand,FiveXSitToStand,ModifiedCtSib",
//         features:"AdvancedDataTools,AdvancedCsvExport,BulkUpload,LoadExternalVideo,FpmExport,PatientGroups,RiskOfFallWorkflow,WhiteLabel,NeutralShoulderRoms,SupineRoms,DualRoms,Workflow,PatientAppInvite"
//     },
//     {
//         displayName:"Kinetisense Flex Academic",
//         modules:"Gait,ClinicalGait,Wheelchair,TimedUpAndGo,FiveXSitToStand,ModifiedCtSib",
//         features:"AdvancedDataTools,AdvancedCsvExport,BulkUpload,LoadExternalVideo,FpmExport,PatientGroups,RiskOfFallWorkflow,WhiteLabel,NeutralShoulderRoms,SupineRoms,DualRoms,Workflow,PatientAppInvite"
//     },
//     {
//         displayName:"Kinetisense Aegis",
//         modules:"ROM,Posture,Functional,Balance,ModifiedVeles,OverheadSquat,PostureAngel,ReverseLunge,VerticalJump,SingleLegHop,Gait,ClinicalGait,Wheelchair,TimedUpAndGo,SitToStand,FiveXSitToStand,ModifiedCtSib",
//         features:"AdvancedDataTools,AdvancedCsvExport,BulkUpload,FpmExport,PatientGroups,RiskOfFallWorkflow,WhiteLabel,NeutralShoulderRoms,SupineRoms,DualRoms,Workflow,KAMS,KAMSSeniorLiving,Branding_Aegis,PatientAppInvite"
//     },
//     {
//         displayName:"Kinetisense PTGenie",
//         modules:"ROM,Posture,Functional,Balance,ModifiedVeles,OverheadSquat,PostureAngel,ReverseLunge,VerticalJump,SingleLegHop,Gait,ClinicalGait,Wheelchair,TimedUpAndGo,SitToStand,FiveXSitToStand,ModifiedCtSib",
//         features:"AdvancedDataTools,AdvancedCsvExport,BulkUpload,LoadExternalVideo,FpmExport,PatientGroups,RiskOfFallWorkflow,WhiteLabel,NeutralShoulderRoms,SupineRoms,DualRoms,Workflow,KAMS,Branding_PTGenie,PatientAppInvite"
//     },
//     {
//         displayName:"Kinetisense Symbria",
//         modules:"ROM,Posture,Functional,Balance,ModifiedVeles,OverheadSquat,PostureAngel,ReverseLunge,VerticalJump,SingleLegHop,Gait,ClinicalGait,Wheelchair,TimedUpAndGo,SitToStand,FiveXSitToStand,ModifiedCtSib",
//         features:"AdvancedDataTools,AdvancedCsvExport,BulkUpload,LoadExternalVideo,FpmExport,PatientGroups,RiskOfFallWorkflow,WhiteLabel,NeutralShoulderRoms,SupineRoms,DualRoms,Workflow,KAMS,Branding_Symbria,PatientAppInvite"
//     }
    
// ];

export const OrganizationThemes = [
    "Kinetisense",
    "PTGenie",
    "Symbria"
]

export const OrganizationUserRoles = [
    "Administrator",
    "Viewer",
    "Dashboard"
]

export const CorrectivesMarkets = [
    "General",
    "Senior Living"
]

export const CorrectivesGroups = [
    "Core",
    "RockTape",
    "PTGenie"
]

export const CorrectivesLevels = [
    "1",
    "2",
    "3"
]

export const CorrectivesJoints = [
    "ANKLE",
    "CERVICAL",
    "CORE",
    "HIP",
    "KNEE",
    "LUMBAR",
    "OCCIPITAL",
    "SCAPULA",
    "SHOULDER",
    "SI_JOINT",
    "THORACIC",
    "WRIST"
]

export const languageList = [
    {id:"EN-US", name:"English (USA)"}, 
    {id:"FR-FR", name:"French (France)"}, 
    {id:"ES", name:"Spanish"}, 
    {id:"DE", name:"German"}, 
    {id:"PT-BR", name:"Portuguese (Brasil)"}, 
    {id:"PL", name:"Polish"}, 
    {id:"ZH-CH", name:"Chinese (Simplified)"}, 
    {id:"JA", name:"Japanese"},
    {id:"NL-NL", name:"Dutch (Netherlands"},
]

export const ClinicFields = [
   {name:"Clinic.Name",type:"string"},
   {name:"Clinic.VatNumber",type:"string"},
   {name:"Clinic.PatientGroup",type:"string"},
   {name:"Clinic.Address",type:"string"},
   {name:"Clinic.Phone",type:"string"},
   {name:"CurrentUser.IsAdministrator",type:"bool"}
]

export const PatientFields = [
    {name: "Patient.Name", type:"string"},
    // {name: "Patient.MiddleName", type:"string"},
    {name: "Patient.Surname", type:"string"},
    {name: "Patient.Email", type:"string"},
    {name: "Patient.IsMale", type:"bool"},
    {name: "Patient.BirthDay", type:"date"},
    {name: "Patient.Phone", type:"string"},
    {name: "Patient.Address", type:"string"},
    //{name: "Patient.HealthcareNumber", type:"string"},
    {name: "Patient.Height", type:"number"},
    {name: "Patient.Weight", type:"number"},
    {name: "Patient.Notes", type:"string"},
    // {name: "Patient.School", type:"string"},
    {name: "Patient.IsRightHanded", type:"bool"},
    {name: "Patient.IsRightFooted", type:"bool"},
    {name: "Patient.IsClubSportParticipant", type:"bool"},
    {name: "Patient.IsHighSchoolSportParticipant", type:"bool"},
    {name: "Patient.HasPlayedContactSport", type:"bool"},
    {name: "Patient.SportsPlayed_csv", type:"string"},
    {name: "Patient.HasKnownConditions", type:"bool"},
    {name: "Patient.NumberOfKnownConditions", type:"number"},
    {name: "Patient.HasKnownConcussions", type:"bool"},
    {name: "Patient.NumberOfKnownConcussions", type:"number"},
    {name: "Patient.HasMusculoSkeletalInjuries", type:"bool"},
    {name: "Patient.MusculoSkeletalInjuries_csv", type:"bool"},
    {name: "Patient.IsWearingGlasses", type:"bool"},
    {name: "Patient.HasVisionDisorder", type:"bool"},
    {name: "Patient.VisionDisorders_csv", type:"string"},
    {name: "Patient.HasHearingLoss", type:"bool"},
    {name: "Patient.HearingLoss", type:"number"},
    {name: "Patient.HasLearningDisability", type:"bool"},
    {name: "Patient.PatientGroup", type:"string"}
]

export const PractitionerFields = [
    {name: "Practitioner.Name", type:"string"},
    // {name: "Practitioner.MiddleName", type:"string"},
    {name: "Practitioner.Surname", type:"string"},
    {name: "Practitioner.Email", type:"string"},
    {name: "Practitioner.Phone", type:"string"},
    {name: "Practitioner.Address", type:"string"},
    {name: "Practitioner.Bio", type:"string"},
    {name: "Practitioner.Specialty", type:"string"},
    {name: "Practitioner.IsAdministrator", type:"bool"},
    {name: "Practitioner.IsOperator", type:"bool"},
]

export const AssessmentFields = [
    {name: "Assessment.HydrationLevel", type:"number"},
    {name: "Assessment.EnergyLevel",  type:"number"},
    {name: "Assessment.PainType",  type:"string"},
    {name: "Assessment.PainIntensity",  type:"number"},
    {name: "Assessment.SensorType",  type:"string"},
    {name: "Assessment.IsShared",  type:"bool"},
    {name: "Assessment.MovementSkipped",  type:"bool"}
]
export const AssessmentGroupFields = [
    {name: "AssessmentGroup.Title", type:"string"}
]

export const SSOTypes = [
    "None",
    "GoogleOAuth",
    "AzureSAML20",
    "AzureOAuth",
    "HL7OAuth"
]

export const ControllerList = [
    {value: "Clinic", label: "Clinic"},
    {value: "Practitioner", label: "Practitioner"},
    {value: "Patient", label: "Patient"},
    {value: "Address", label: "Address"},
    {value: "Phone", label: "PhoneNumber"},
    {value: "Subscription", label: "Subscription"},
    {value: "UploadFile", label: "UploadFile"},
    {value: "Organization", label: "Organization"},
    {value: "PresetWorkflow", label: "PresetWorkflow"},
    
    {value: "Balance", label: "BalanceAssessment"},
    {value: "Functional", label: "FunctionalAssessment"},
    {value: "OverheadSquat", label: "OverheadSquatAssessment"},
    {value: "ROM", label: "ROMAssessment"},
    {value: "ReverseLunge", label: "ReverseLungeAssessment"},
    {value: "SingleLegHop", label: "SingleLegHopAssessment"},
    // {value: "SidePostural", label: "SidePostural"},
    {value: "VerticalJump", label: "VerticalJumpAssessment"},
    {value: "WallAngel", label: "WallAngelAssessment"},
    {value: "Permissions", label: "Permissions"},
    {value: "AssessmentFrame", label: "AssessmentFrame"},
    
    {value: "AssessmentGroup", label: "Assessment"},
    {value: "GroupBalance", label: "GroupBalance"},
    {value: "GroupFunctional", label: "GroupFunctional"},
    {value: "GroupOverheadSquat", label: "GroupOverheadSquat"},
    {value: "GroupROM", label: "GroupROM"},
    {value: "GroupReverseLunge", label: "GroupReverseLunge"},
    {value: "GroupSingleLegHop", label: "GroupSingleLegHop"},
    // {value: "GroupSidePostural", label: "GroupSidePostural"},
    {value: "GroupVerticalJump", label: "GroupVerticalJump"},
    {value: "GroupWallAngel", label: "GroupWallAngel"},
    {value: "Workflow", label: "Workflow"},
    
    {value: "Correctives", label: "Correctives"},
    {value: "CorrectiveProtocol", label: "CorrectiveProtocol"},
    {value: "Exercise", label: "Exercise"},
    {value: "ExerciseText", label: "ExerciseText"},
    {value: "Equipment", label: "Equipment"},
    {value: "EquipmentText", label: "EquipmentText"},
    {value: "Protocol", label: "Protocol"},
    {value: "ProtocolSession", label: "ProtocolSession"},

    {value: "Clinic CF", label: "Clinic CF"},
    {value: "Practitioner CF", label: "Practitioner CF"},
    {value: "Patient CF", label: "Patient CF"},
    {value: "Assessment CF", label: "Assessment CF"},
    {value: "Workflow CF", label: "Workflow CF"},
    {value: "CF Metadata", label: "CF Metadata"},
]

export const WorkflowAssessmentList = [
    {name: "NeckExtension", module:"ROM"},
    {name: "NeckExtensionSideOn", module:"ROM"},
    {name: "NeckFlexion", module:"ROM"},
    {name: "NeckFlexionSideOn", module:"ROM"},
    {name: "NeckLateralFlexionLeft", module:"ROM"},
    {name: "NeckLateralFlexionRight", module:"ROM"},
    {name: "NeckRotationLeft", module:"ROM"},
    {name: "NeckRotationRight", module:"ROM"},
    {name: "ShoulderRightAbduction", module:"ROM"},
    {name: "ShoulderRightAdduction", module:"ROM"},
    {name: "ShoulderRightExtension", module:"ROM"},
    {name: "ShoulderRightExternalRotation", module:"ROM"},
    {name: "ShoulderRightExternalRotationNeutral", module:"ROM"},
    {name: "ShoulderRightFlexion", module:"ROM"},
    {name: "ShoulderRightInternalRotation", module:"ROM"},
    {name: "ShoulderRightInternalRotationNeutral", module:"ROM"},
    {name: "ShoulderRightElevation", module:"ROM"},
    {name: "ShoulderRightBehindBackReach", module:"ROM"},
    {name: "ShoulderRightFlexionSupine", module:"ROM"},
    {name: "ShoulderRightExtensionSupine", module:"ROM"},
    {name: "ShoulderRightInternalRotationSupine", module:"ROM"},
    {name: "ShoulderRightExternalRotationSupine", module:"ROM"},
    {name: "ShoulderRightUnilateralShrug", module:"ROM"},
    {name: "ShoulderRightElbowRightAbductionFlexion", module:"ROM"}, // Dual ROM
    {name: "ShoulderLeftAbduction", module:"ROM"},
    {name: "ShoulderLeftAdduction", module:"ROM"},
    {name: "ShoulderLeftExtension", module:"ROM"},
    {name: "ShoulderLeftExternalRotation", module:"ROM"},
    {name: "ShoulderLeftExternalRotationNeutral", module:"ROM"},
    {name: "ShoulderLeftFlexion", module:"ROM"},
    {name: "ShoulderLeftInternalRotation", module:"ROM"},
    {name: "ShoulderLeftInternalRotationNeutral", module:"ROM"},
    {name: "ShoulderLeftElevation", module:"ROM"},
    {name: "ShoulderLeftBehindBackReach", module:"ROM"},
    {name: "ShoulderLeftFlexionSupine", module:"ROM"},
    {name: "ShoulderLeftExtensionSupine", module:"ROM"},
    {name: "ShoulderLeftInternalRotationSupine", module:"ROM"},
    {name: "ShoulderLeftExternalRotationSupine", module:"ROM"},
    {name: "ShoulderLeftUnilateralShrug", module:"ROM"},
    {name: "ShoulderLeftElbowLeftAbductionFlexion", module:"ROM"}, // Dual ROM
    {name: "BackExtension", module:"ROM"},
    {name: "BackFlexion", module:"ROM"},
    {name: "BackLateralFlexionLeft", module:"ROM"},
    {name: "BackLateralFlexionRight", module:"ROM"},
    {name: "BackRotationLeft", module:"ROM"},
    {name: "BackRotationRight", module:"ROM"},
    {name: "ElbowRightExtension", module:"ROM"},
    {name: "ElbowRightFlexion", module:"ROM"},
    {name: "ElbowRightPronation", module:"ROM"},
    {name: "ElbowRightSupination", module:"ROM"},
    {name: "ElbowRightFlexionSupine", module:"ROM"},
    {name: "ElbowRightExtensionSupine", module:"ROM"},
    {name: "ElbowLeftExtension", module:"ROM"},
    {name: "ElbowLeftFlexion", module:"ROM"},
    {name: "ElbowLeftPronation", module:"ROM"},
    {name: "ElbowLeftSupination", module:"ROM"},
    {name: "ElbowLeftFlexionSupine", module:"ROM"},
    {name: "ElbowLeftExtensionSupine", module:"ROM"},
    {name: "HipRightAbduction", module:"ROM"},
    {name: "HipRightAdduction", module:"ROM"},
    {name: "HipRightExtension", module:"ROM"},
    {name: "HipRightFlexion", module:"ROM"},
    {name: "HipRightInternalRotation", module:"ROM"},
    {name: "HipRightExternalRotation", module:"ROM"},
    {name: "HipRightFlexionSupine", module:"ROM"},
    {name: "HipRightExtensionSupine", module:"ROM"},
    {name: "HipRightKneeRightFlexionExtensionSupine", module:"ROM"}, // Dual ROM
    {name: "HipLeftAbduction", module:"ROM"},
    {name: "HipLeftAdduction", module:"ROM"},
    {name: "HipLeftExtension", module:"ROM"},
    {name: "HipLeftFlexion", module:"ROM"},
    {name: "HipLeftInternalRotation", module:"ROM"},
    {name: "HipLeftExternalRotation", module:"ROM"},
    {name: "HipLeftFlexionSupine", module:"ROM"},
    {name: "HipLeftExtensionSupine", module:"ROM"},
    {name: "HipLeftKneeLeftFlexionExtensionSupine", module:"ROM"}, // Dual RO
    {name: "KneeRightExtension", module:"ROM"},
    {name: "KneeRightFlexion", module:"ROM"},
    {name: "KneeRightFlexionSupine", module:"ROM"},
    {name: "KneeRightExtensionSupine", module:"ROM"},
    {name: "KneeLeftExtension", module:"ROM"},
    {name: "KneeLeftFlexion", module:"ROM"},
    {name: "KneeLeftFlexionSupine", module:"ROM"},
    {name: "KneeLeftExtensionSupine", module:"ROM"},
    {name: "Functional", module:"Functional"},
    {name: "BalanceBothFeetDownEyesOpenFoam", module:"Balance"},
    {name: "BalanceBothFeetDownEyesOpenNoFoam", module:"Balance"},
    {name: "BalanceBothFeetDownEyesClosedFoam", module:"Balance"},
    {name: "BalanceBothFeetDownEyesClosedNoFoam", module:"Balance"},
    {name: "BalanceLeftFootDownEyesOpenFoam", module:"Balance"},
    {name: "BalanceLeftFootDownEyesOpenNoFoam", module:"Balance"},
    {name: "BalanceLeftFootDownEyesClosedFoam", module:"Balance"},
    {name: "BalanceLeftFootDownEyesClosedNoFoam", module:"Balance"},
    {name: "BalanceRightFootDownEyesOpenFoam", module:"Balance"},
    {name: "BalanceRightFootDownEyesOpenNoFoam", module:"Balance"},
    {name: "BalanceRightFootDownEyesClosedFoam", module:"Balance"},
    {name: "BalanceRightFootDownEyesClosedNoFoam", module:"Balance"},
    {name: "BalanceLeftTendumRightFootDownEyesOpenFoam", module:"Balance"},			// Left foot in front of right
    {name: "BalanceLeftTendumRightFootDownEyesOpenNoFoam", module:"Balance"},		// Left foot in front of right
    {name: "BalanceLeftTendumRightFootDownEyesClosedFoam", module:"Balance"},		// Left foot in front of right
    {name: "BalanceLeftTendumRightFootDownEyesClosedNoFoam", module:"Balance"},		// Left foot in front of right
    {name: "BalanceRightTendumLeftFootDownEyesOpenFoam", module:"Balance"},			// Right foot in front of left
    {name: "BalanceRightTendumLeftFootDownEyesOpenNoFoam", module:"Balance"},		// Right foot in front of left
    {name: "BalanceRightTendumLeftFootDownEyesClosedFoam", module:"Balance"},		// Right foot in front of left
    {name: "BalanceRightTendumLeftFootDownEyesClosedNoFoam", module:"Balance"},		// Right foot in front of left
    {name: "OverheadSquat", module:"OverheadSquat"},
    {name: "ReverseLunge", module:"ReverseLunge"},
    {name: "VerticalJump", module:"VerticalJump"},
    {name: "Posture", module:"Posture"},
    {name: "PostureAngel", module:"PostureAngel"},
    {name: "SingleLegHop", module:"SingleLegHop"},
    {name: "Gait", module:"Gait"},
    {name: "ClinicalGait", module:"ClinicalGait"},
    {name: "TimedUpAndGo", module:"TimedUpAndGo"},
    {name: "SitToStand", module:"SitToStand"},
    {name: "FiveXSitToStand", module:"FiveXSitToStand"},
    {name: "ModifiedCtSib", module:"ModifiedCtSib"},
    {name: "HeelRaise", module:"HeelRaise"},
    {name: "HandFlexibility", module:"HandFlexibility"},
    {name: "GolfPosture", module:"GolfPosture"},
    {name: "GolfStanceTorsoRotation", module:"GolfStanceTorsoRotation"},
    {name: "GolfStancePelvicRotation", module:"GolfStancePelvicRotation"},
    {name: "PronePlankPosture", module:"PronePlankPosture"},
    {name: "SidePlankPosture", module:"SidePlankPosture"},
    {name: "BridgePosture", module:"BridgePosture"},
    {name: "GolfSwingAnalysis", module:"GolfSwingAnalysis"}
]

export const ApplicationList = [
    {name: "LicenceMaintenance", accessList: "LicenceReader,LicenceWriter,LicenceAdmin"},
    {name: "UserManagement", accessList: "UserReader,UserWriter,UserAdmin"},
    {name: "Settings", accessList: "SettingsReader,SettingsWriter,SettingsAdmin"},
    {name: "Correctives", accessList: "CorrectivesReader,CorrectivesWriter,CorrectivesAdmin"},
    {name: "PractitionerApp", accessList: "PractAppReader,PractAppWriter,PractAppAdmin,PractAppReport,PractAppExport"},
    {name: "Dashboard", accessList: "DashboardReader,DashboardWriter,DashboardAdmin"},
    {name: "KinetisenseDashboard", accessList: "KinDashboardReader,KinDashboardWriter,KinDashboardAdmin"},
]